import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { EMAIL, ADDRESS_LINES } from "../constants";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-slate-900 text-white">
    <div className="mx-auto max-w-7xl px-6 py-20 md:px-10">
      <Link to="/" data-testid="footer-logo" className="block w-fit">
        <span className="font-serif text-5xl font-medium tracking-tight text-white transition-colors duration-300 hover:text-blue-400 md:text-7xl">
          EY Tech <em className="text-blue-400">LLC</em>
        </span>
      </Link>
      <p className="mt-4 max-w-md text-sm leading-relaxed text-slate-400">
        Clear compliance packs for US and UK businesses. What the rule
        requires, what to change — no scare tactics.
      </p>

      <div className="mt-14 grid grid-cols-1 gap-12 border-t border-white/10 pt-12 md:grid-cols-3">
        <div>
          <p className="mb-4 text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">
            Navigate
          </p>
          <div className="flex flex-col gap-3">
            <Link data-testid="footer-link-home" to="/" className="w-fit text-sm text-slate-300 transition-colors duration-300 hover:text-blue-400">
              Home
            </Link>
            <Link data-testid="footer-link-report" to="/report" className="w-fit text-sm text-slate-300 transition-colors duration-300 hover:text-blue-400">
              Website Issue Report
            </Link>
            <Link data-testid="footer-link-email-check" to="/email-check" className="w-fit text-sm text-slate-300 transition-colors duration-300 hover:text-blue-400">
              Email Delivery Check
            </Link>
            <Link data-testid="footer-link-eu-pack" to="/eu-sell-through" className="w-fit text-sm text-slate-300 transition-colors duration-300 hover:text-blue-400">
              EU Sell-Through Pack
            </Link>
            <Link data-testid="footer-link-contact" to="/contact" className="w-fit text-sm text-slate-300 transition-colors duration-300 hover:text-blue-400">
              Contact
            </Link>
          </div>
        </div>
        <div>
          <p className="mb-4 text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">
            Contact
          </p>
          <a
            data-testid="footer-email-link"
            href={`mailto:${EMAIL}`}
            className="group flex w-fit items-center gap-2 text-sm text-slate-300 transition-colors duration-300 hover:text-blue-400"
          >
            {EMAIL}
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
        </div>
        <div>
          <p className="mb-4 text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">
            Registered Office
          </p>
          <address data-testid="footer-address" className="text-sm not-italic leading-relaxed text-slate-300">
            {ADDRESS_LINES.map((line) => (
              <span key={line} className="block">
                {line}
              </span>
            ))}
          </address>
        </div>
      </div>

      <div className="mt-14 border-t border-white/10 pt-8">
        <div className="flex flex-col justify-between gap-4 md:flex-row md:items-center">
          <p data-testid="footer-copyright" className="text-xs text-slate-500">
            © 2026 EY TECH LLC — All Rights Reserved
          </p>
          <p className="text-xs text-slate-600">
            Wilmington / Delaware — USA
          </p>
        </div>
        <p data-testid="footer-disclaimer" className="mt-6 text-xs leading-relaxed text-slate-500">
          EY TECH LLC is not affiliated with Ernst &amp; Young (EY). This site is not legal advice.
        </p>
      </div>
    </div>
  </footer>
);
